<template>
  <div class="vue-back-to-top" v-show="visible">
    <b-button rounded variant="outline-primary" class="pt-0" style="border-radius: 50%">
         <i @click="backToTop" class="fa fa-angle-up fa-3x" aria-hidden="true"></i>
     </b-button>
  </div>
</template>
<style lang="scss">
  @import "../../theme/nexum-bootstrap";
  @import "../../../node_modules/bootstrap/scss/bootstrap.scss";
  .vue-back-to-top {
    position: fixed;
    bottom: 1.5rem;
    left: 1rem ;
    color: $brand-primary;
  }
</style>
<script>
  export default {
    name: 'back-top-button',
    data() {
      return {
        isVisible: false,
        visible: false,
      };
    },
    props: {
      visibleOffset: {
        type: [String, Number],
        default: 300,
      },
    },
    created() {
      const catchScroll = () => {
        // eslint-disable-next-line radix
        this.visible = (window.pageYOffset > parseInt(this.visibleOffset));
      };
      window.smoothscroll = () => {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(window.smoothscroll);
          window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)));
        }
      };
      window.onscroll = catchScroll;
    },
    methods: {
      backToTop() {
        window.smoothscroll();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/features/back-top-button/BackTopButton.vue